<template>
  <div class="screen">
    <el-select v-model="body.fgSupplier" size="small" multiple collapse-tags clearable filterable
               :placeholder="$t('select_fg_supplier')" v-if="showFgSupplier" style="width: 200px">
      <el-option v-for="item in fgSupplierList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-cascader v-model="processModel" :props="props" :options="processOptions" size="small" collapse-tags clearable
                 filterable :placeholder="showSupplier ? $t('select_supplier') : $t('select_cpt_supplier')"
                 @change="changeCPTSupplier" :filter-method="changeProcess"
                 v-if="showCptSupplier || showCptSupplierFirst || showSupplier || showProcess"
                 style="width: 300px"></el-cascader>
    <el-cascader v-model="processModel" :props="props" :options="processOptions" size="small" collapse-tags clearable
                 filterable :placeholder="$t('select_ccs_supplier')"
                 @change="changeCPTSupplier" :filter-method="changeProcess"
                 v-if="showCcsSupplier "
                 style="width: 300px"></el-cascader>
    <el-select v-model="body.cptQpl" size="small" multiple collapse-tags clearable
               :placeholder="$t('select_cpt_qpl')" v-if="showCptQpl" style="width: 200px">
      <el-option v-for="item in cptQplList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="body.yarnSupplier" size="small" multiple collapse-tags clearable filterable
               :placeholder="$t('select_yarn_supplier')" v-if="showYarnSupplier" style="width: 160px">
      <el-option v-for="item in yarnSupplier" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="body.process" size="small" multiple collapse-tags clearable
               :placeholder="$t('selection_process')" v-if="showAloneProcess" style="width: 170px">
      <el-option v-for="item in processList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="body.close_type" size="small" clearable :placeholder="$t('select_cpt_responsibility')"
               style="width: 180px" v-if="showResponsibility">
      <el-option v-for="item in cptResponsibilityList" :key="item.value" :label="item.label"
                 :value="item.value"></el-option>
    </el-select>
    <el-select v-model="body.status" size="small" multiple collapse-tags clearable
               :placeholder="$t('select_status')" style="width: 200px" v-if="showMultipleStatus">
      <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-select v-model="body.status" size="small" clearable :placeholder="$t('select_status')" style="width: 125px"
               v-else-if="showStatus">
      <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-date-picker v-model="body.date" type="date" :placeholder="`Select Date`" size="small"
                    v-if="dataType === 'date'" style="width: 150px"></el-date-picker>
    <el-date-picker v-model="body.month" type="month" :placeholder="$t('select_month')" size="small"
                    v-if="dataType === 'month'" style="width: 150px"></el-date-picker>
    <el-date-picker v-model="body.year" type="year" :placeholder="$t('select_year')" size="small"
                    v-if="dataType === 'year'" style="width: 150px"></el-date-picker>
    <el-date-picker v-model="body.dateRange" type="daterange" range-separator="-" size="small"
                    :start-placeholder="$t('start_date')" :end-placeholder="$t('end_date')"
                    v-if="dataType === 'daterange'" style="width: 220px"></el-date-picker>
    <el-date-picker v-model="body.dateRange" type="monthrange" range-separator="-" size="small"
                    :start-placeholder="$t('start_date')" :end-placeholder="$t('end_date')"
                    v-if="dataType === 'monthrange'" style="width: 220px"></el-date-picker>
    <el-cascader v-model="body.typeID" :options="claimTypeList" :props="claimTypeProps"
                 :placeholder="$t('selection_claim_type')" size="small" collapse-tags clearable style="width: 220px"
                 v-if="showClaimType"></el-cascader>
    <slot></slot>
    <el-input v-model="body.keyword" size="small" :placeholder="$t('input_keyword_search')"
              style="width: 240px; margin-bottom: 10px" v-if="showKeyword"></el-input>
    <el-button type="primary" size="small" @click="search">{{$t('search')}}</el-button>
    <el-button size="small" @click="empty">{{$t('empty')}}</el-button>
    <el-button type="primary" size="small" @click="exportFile" v-if="showExport">{{$t('export')}}</el-button>
    <el-button size="small" @click="sampleRequests" v-if="showSampleRequests">{{$t('sample_requests')}}</el-button>
    <el-button size="small" @click="courierNumber" v-if="showCourierNumber">{{$t('courier_number')}}</el-button>
  </div>
</template>

<script>
  import moment from 'moment'

  let timer;
  export default {
    props: {
      showStatus: {
        type: Boolean,
        default: false
      },
      dataType: {
        type: String,
        default: 'daterange'
      },
      showSupplier: {
        type: Boolean,
        default: false
      },

      selectSupplierType: {
        type: String,
        default: ''
      },

      showCptSupplier: {
        type: Boolean,
        default: false
      },
      showCcsSupplier: {
        type: Boolean,
        default: false
      },
      showCptSupplierFirst: {
        type: Boolean,
        default: false
      },

      showYarnSupplier: {
        type: Boolean,
        default: false
      },

      showFgSupplier: {
        type: Boolean,
        default: false
      },
      showCptQpl: {
        type: Boolean,
        default: false
      },
      showProcess: {
        type: Boolean,
        default: false
      },
      showKeyword: {
        type: Boolean,
        default: false
      },
      showClaimType: {
        type: Boolean,
        default: false
      },
      showExport: {
        type: Boolean,
        default: true
      },
      showAloneProcess: {
        type: Boolean,
        default: false
      },
      showMultipleStatus: {
        type: Boolean,
        default: false
      },

      showResponsibility: {
        type: Boolean,
        default: false
      },
      showSampleRequests: {
        type: Boolean,
        default: false
      },
      showCourierNumber: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        processModel: [],
        processOptions: [],
        fgSupplierList: [],
        cptSupplierList: [],
        supplierList: [],
        yarnSupplier: [],
        processList: [],
        cptQplList: [],
        cptResponsibilityList: [{
          label: 'CPT Responsibility',
          value: 1
        }, {
          label: 'Not CPT Responsibility',
          value: 2
        }],
        statusList: [{
          label: 'Open',
          value: 'Open'
        }, {
          label: 'Pending',
          value: 'Pending'
        }, {
          label: 'Responsibility Defined',
          value: 'TClosed'
        }, {
          label: 'Final Closed',
          value: 'FClosed'
        }, {
          label: 'Not responsibility Closed',
          value: 'NRClosed'
        }],
        body: {
          fgSupplier: [],
          cptQpl: [],
          cptSupplier: [],
          process: [],
          close_type: '',
          status: '',
          keyword: '',
          supplier: [],
          yarnSupplier: [],
          dateRange: [],
          year: '',
          typeID: [],
          date: '',
          month: ''
        },
        claimTypeProps: {multiple: true},
        claimTypeList: [],
        props: {
          value: 'id',
          label: 'name',
          children: 'supplier_list',
          multiple: true,
        },
      }
    },

    created() {
      // this.getProcess();
      const _ = this;
      this.props = {
        value: 'id',
        label: 'name',
        children: 'supplier_list',
        multiple: true,
        checkStrictly: false
      }
    },

    methods: {
      selectAttachSupplier(type) {
        this.$api.selectAttachSupplier({
          type: type
        }).then(res => {
          this.processOptions = res.data.data;
          this.optionsCopy = res.data.data;
          console.log(this.processOptions)
        })
      },
      getProcess(e) {
        if (!e) {
          this.$api.getProcessList().then(res => {
            this.processList = res.data.data;
          })
        } else {
          this.$api.selectByTypeProcess({
            type: e
          }).then(res => {
            this.processList = res.data.data;
          })
        }

      },

      // 获取成品供应商
      getFGSupplier() {
        this.getSupplier(1)
      },

      // 获取面料供应商
      getCPTSupplier() {
        this.getSupplier(2)
      },

      // 获取纱线供应商
      getYarnSupplier() {
        this.getSupplier(3)
      },

      // 获取供应商
      getSupplier(type) {
        this.$api.selectByTypeSupplier({
          type: type,
          limit_role: 0
        }).then(res => {
          if (!type) {
            this.supplierList = res.data.data;
          }
          if (type === 1) {
            this.fgSupplierList = res.data.data;
          }
          if (type === 2) {
            this.cptSupplierList = res.data.data;
          }
          if (type === 3) {
            this.yarnSupplier = res.data.data;
          }
        })
      },

      // 获取CPT QPL
      getCPTQPL() {
        this.getQPL(3);
      },

      // 获取QPL
      getQPL(role) {
        this.$api.selectQPLListByRole({
          role: role
        }).then(res => {
          if (role === 2) {
            this.fgQplList = res.data.data;
          }
          if (role === 3) {
            this.cptQplList = res.data.data;
          }
          if (role === 4) {
            // this.yarnQplList = res.data.data;
          }
        })
      },

      // 获取 Claim Type
      getClaimTypeList(type) {
        this.$api.getCategotyList({
          system_type: type
        }).then(res => {
          this.claimTypeList = res.data.data;
        })
      },

      changeProcess(node, keyword) {
        if (node.data.name.indexOf(keyword) > -1) {
          return true
        }
        if (node.data.supplier_code && node.data.supplier_code.indexOf(keyword) > -1) {
          return true
        }
        if (node.data.contact_person && node.data.contact_person.indexOf(keyword) > -1) {
          return true
        }
        if (node.data.account_email && node.data.account_email.indexOf(keyword) > -1) {
          return true
        }
        if (node.data.phone && node.data.phone.indexOf(keyword) > -1) {
          return true
        }
      },

      // 点击搜索
      search() {
        let body = {};
        console.log(this.body);

        for (let key in this.body) {
          if (this.body.hasOwnProperty(key) && this.body[key]) {
            body[key] = this.body[key];
          }
          if (key === 'dateRange') {
            console.log(this.body.dateRange);
            if (this.body.dateRange && this.body.dateRange.length === 2) {
              body.dateRange = [moment(this.body.dateRange[0]).format('YYYY-MM-DD'), moment(this.body.dateRange[1]).format('YYYY-MM-DD')]
            } else {
              body.dateRange = ['', ''];
            }
          }
          if (key === 'date') {
            if (this.body.date) {
              body.date = moment(this.body.date).format('YYYY-MM-DD');
            }
          }
          if (key === 'month' && this.dataType === 'month') {
            if (this.body.month) {
              body.year = moment(this.body.month).format('YYYY-MM');
            }
          }
          if (key === 'year' && this.dataType === 'year') {
            if (this.body.year) {
              console.log(this.body.year);
              body.year = new Date(this.body.year).getFullYear();
              console.log(body.year)
            }
          }
        }
        console.log(body);
        this.$emit('search', body);
      },

      // 重置搜索框
      empty() {
        this.reset();
        this.$emit('empty', this.body);
      },

      // 重置
      reset() {
        this.processModel = [];
        this.body = {
          fgSupplier: [],
          cptQpl: [],
          cptSupplier: [],
          process: [],
          close_type: '',
          status: '',
          keyword: '',
          supplier: [],
          yarnSupplier: [],
          dateRange: [],
          date: '',
          typeID: []
        }
      },

      exportFile() {
        let body = {};
        for (let key in this.body) {
          if (this.body.hasOwnProperty(key) && this.body[key]) {
            body[key] = this.body[key];
          }
          if (key === 'dateRange') {
            if (this.body.dateRange.length === 2) {
              body.dateRange = [moment(this.body.dateRange[0]).format('YYYY-MM-DD'), moment(this.body.dateRange[1]).format('YYYY-MM-DD')]
            }
          }
          if (key === 'date') {
            if (this.body.date) {
              body.date = moment(this.body.date).format('YYYY-MM-DD');
            }
          }
          if (key === 'month') {
            if (this.body.month) {
              body.year = moment(this.body.month).format('YYYY-MM');
            }
          }
          if (key === 'year') {
            if (this.body.year) {
              body.year = new Date(this.body.year).getFullYear()
            }
          }
        }
        this.$emit('exportFile', body);
      },

      //
      changeCPTSupplier(e) {
        console.log(e);
        this.body.process = [];
        this.body.supplier = [];
        this.body.cptSupplier = [];

        for (let i = 0; i < e.length; i++) {
          if (this.body.process.indexOf(e[i][0]) === -1) {
            this.body.process.push(e[i][0])
          }
          // }
          if (e[i][1]) {
            if (this.showSupplier) {
              this.body.supplier.push(e[i][1]);
            } else {
              this.body.cptSupplier.push(e[i][1]);
            }
          }
        }
      },

      sampleRequests() {
        this.$emit('sampleRequests')
      },

      courierNumber() {
        this.$emit('courierNumber')
      }
    }
  }
</script>

<style lang="scss">
  .screen {
    /*display: flex;*/
    /*align-items: center;*/
    /*flex-wrap: wrap;*/

    .el-cascader__tags .el-tag {
      max-width: 140px;
    }


    .el-select, .el-date-editor, .el-input, .el-cascader {
      margin-right: 3px;
    }

    .el-select, .el-date-editor, .el-button, .el-cascader {
      margin-bottom: 10px;

    }

    .el-button {
      margin-left: 6px;
    }

    .el-select .el-tag {
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  }
</style>



// WEBPACK FOOTER //
// src/common/vue/screen.vue